import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LogOut } from 'lucide-react';
import { cn } from '@/shared/lib/cn';
import { Button, Tooltip } from '@/shared/ui';
export function NavUser({ user, onLogout, compact = false }) {
    const label = user.name ?? user.email ?? user.sub;
    const logoutLabel = label ? `Выйти · ${label}` : 'Выйти';
    if (compact) {
        return (_jsx("div", { className: "flex w-full items-center justify-center px-1", children: _jsx(Tooltip, { label: logoutLabel, side: "right", children: _jsx(Button, { variant: "ghost", size: "icon", "aria-label": logoutLabel, onClick: () => {
                        void onLogout();
                    }, children: _jsx(LogOut, { className: "h-4 w-4" }) }) }) }));
    }
    return (_jsxs("div", { className: cn('flex w-full items-center gap-2 px-4'), children: [_jsxs("div", { className: "min-w-0 flex-1", children: [_jsx("p", { className: "truncate text-sm font-medium text-foreground", children: label }), user.email ? (_jsx("p", { className: "truncate text-xs text-muted-foreground", children: user.email })) : null] }), _jsx(Button, { variant: "ghost", size: "icon", "aria-label": "\u0412\u044B\u0439\u0442\u0438", onClick: () => {
                    void onLogout();
                }, children: _jsx(LogOut, { className: "h-4 w-4" }) })] }));
}
